import { IoMdCheckmarkCircleOutline } from "react-icons/io";

const NoOcurrence = ({ message = "Nada consta" }) => {
  return (
    <div className="mt-3">
      <div className="bg-green-50 border border-green-200 rounded-xl p-4 flex items-center gap-3 shadow-sm">
        <IoMdCheckmarkCircleOutline fontSize={26} className="text-green-500" />
        <span className="text-green-700 font-medium text-base">{message}</span>
      </div>
    </div>
  );
};

export default NoOcurrence;
